import { iUser } from "../state/userSlice";

export interface iAuth extends iIdentityProvider {
    token: iToken;
    code: string;
    challenge: string;
    verifier: string;
    error?: string;
}

export interface iIdentityProvider {
    type: IdentityProvider;
    integratedGalEnabled: boolean;
    theme: number;
    clientId: string;
    authorizeUrl: string;
    tokenUrl: string;
    responseType: string;
    scope: string;
}

export interface iToken {
    [x: string]: any;
    token_type: string;
    id_token: string;
    expires_in: string;
    access_token: string;
    refresh_token: string;
    tenant_token: string;
}

export interface iTenants {
    tenants: Array<iTenant>;
}

export interface iTenantContext extends iUser {
    token: string;
    theme: number;
}

export interface iTenant {
    name: string;
    key: string;
    token?: string;
    accessToMultipleTenants: boolean;
    theme: number;
    expiresAt: number;
}

export interface iTenantsResponse {
    tenants: Array<iTenant>;
    isAdmin: boolean;
}

export enum IdentityProvider {
    MsEntra = 1,
}
